export const brandInfo = {
  name: '爱液网页版',
  slogan: '即开即用，随时随地轻松在线',
  founded: '2022年',
  users: '500万+',
  description: '爱液网页版是国内领先的在线服务平台，致力于为用户提供无需下载安装、即开即用的便捷在线体验。自2022年上线以来，凭借出色的产品体验和稳定的服务质量，已累计服务超过500万用户。',
  mission: '让每个人都能轻松享受在线服务的便利，消除软件下载安装的门槛，让优质的数字体验触手可及。',
  vision: '成为全球最受欢迎的在线服务平台，让"打开浏览器即可使用"成为每个人的默认选择。',
  values: [
    { title: '用户至上', description: '始终以用户需求为核心，持续优化产品体验' },
    { title: '技术创新', description: '拥抱前沿技术，不断突破在线服务的可能性' },
    { title: '安全可靠', description: '将数据安全放在首位，赢得用户的每一份信任' },
    { title: '开放共赢', description: '与合作伙伴共同成长，构建健康的在线服务生态' },
  ],
  milestones: [
    { year: '2022年3月', event: '爱液网页版正式上线，推出核心在线服务功能' },
    { year: '2022年9月', event: '用户突破50万，完成首轮产品体验优化' },
    { year: '2023年1月', event: '发布V2.0版本，全新视觉设计和功能升级' },
    { year: '2023年6月', event: '用户突破200万，推出移动端深度适配方案' },
    { year: '2023年12月', event: '获评年度最佳在线服务平台，行业影响力持续扩大' },
    { year: '2024年4月', event: '用户突破400万，推出智能推荐引擎' },
    { year: '2024年10月', event: '发布V2.5版本，性能全面优化，加载速度提升40%' },
    { year: '2025年6月', event: '用户突破500万，启动国际化战略' },
    { year: '2026年3月', event: '发布V3.0版本，五大核心功能全面升级' },
  ],
  contact: {
    email: 'support@aiye.com',
    phone: '400-888-9999',
    address: '北京市朝阳区科技园路88号创新大厦18层',
    wechat: 'aiye_official',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};

export const faqData = [
  {
    question: '爱液网页版需要下载安装吗？',
    answer: '不需要。爱液网页版是纯网页端应用，打开浏览器即可使用，无需下载安装任何软件或插件。你可以在任何设备的浏览器上访问，包括Windows电脑、Mac电脑、iPhone、Android手机等。',
  },
  {
    question: '爱液网页版是否免费使用？',
    answer: '爱液网页版提供免费版和高级版两种选择。免费版包含核心基础功能，满足日常使用需求。高级版解锁更多高级功能和更大的使用容量，适合有更高需求的用户。',
  },
  {
    question: '爱液网页版支持哪些浏览器？',
    answer: '爱液网页版全面支持Chrome 90+、Safari 14+、Edge 90+、Firefox 88+等主流浏览器。建议使用Chrome或Edge浏览器以获得最佳体验。',
  },
  {
    question: '在手机上使用体验如何？',
    answer: '爱液网页版针对手机端做了深度优化，采用响应式设计自动适配不同屏幕尺寸。你可以将网页添加到手机主屏幕，获得类似原生应用的体验。',
  },
  {
    question: '我的数据安全吗？',
    answer: '非常安全。爱液网页版采用业界领先的加密技术，所有数据传输使用TLS 1.3加密，存储数据采用AES-256加密标准。我们严格遵守数据保护法规，绝不会出售或分享您的数据。',
  },
  {
    question: '忘记账号密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册邮箱即可收到密码重置链接。如果遇到问题，可以联系在线客服或发送邮件至support@aiye.com获取帮助。',
  },
];